import DataTableNativeML from '@/components/DataTableNativeML';

const TablePage = (props) => {
  const { pagination, total, loading, tableData, setPageData } = props || {};
  const { pageNum, pageSize } = pagination;

  const columns = [
    {
      align: 'center',
      title: '编号',
      id: 'idNum',
      width: 50,
      render: (record) => {
        return <span>{(pageNum - 1) * pageSize + record.idNum}</span>;
      },
    },
    {
      title: '用户名',
      align: 'center',
      id: 'userName',
      key: 'userName',
      width: 50,
    },
    {
      title: '账号',
      align: 'center',
      id: 'userid',
      key: 'userid',
      width: 50,
    },
    {
      title: '行为页面',
      id: 'eventPage',
      key: 'eventPage',
      align: 'center',
      width: 50,
    },
    {
      title: '行为事件名称',
      id: 'eventName',
      key: 'eventName',
      width: 50,
      align: 'center',
    },
    {
      title: '行为发生时间',
      id: 'eventTime',
      key: 'eventTime',
      width: 50,
      align: 'center',
    },
  ];

  return (
    <>
      <DataTableNativeML
        loading={loading}
        paging={true}
        total={total}
        columns={columns}
        page={pagination}
        changePage={(pageObj) => {
          setPageData(pageObj);
        }}
        devicesMinWidth="1136"
        data={tableData}
        columnKey="id"
        np
        showPageSize={false}
      ></DataTableNativeML>
    </>
  );
};
export default TablePage;
